import React from "react";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { LangConstant } from "const";

const SetPasswordForm = ({ onSubmitPasswordForm, onPasswordFormChange, passwordValidated, passwordErrorMsg, form }) => {
  const { t: getLabel } = useTranslation(LangConstant.NS_LOGIN);

  return (
    <form
      onSubmit={onSubmitPasswordForm}
      style={{ maxWidth: 346, width: "100%", margin: "56px auto" }}
    >
      <div className="mb-3">
        <label className="form-label" style={{ fontSize: 15, lineHeight: "20px" }}>
          {getLabel(LangConstant.L_NEW_PASSWORD)}
        </label>
        <input
          id="password"
          type="password"
          className="form-control"
          placeholder={getLabel(LangConstant.P_NEW_PASSWORD)}
          onChange={onPasswordFormChange}
          value={form.password}
          style={{ backgroundColor: "#f5f5f5" }}
        />
      </div>
      <div className="mb-3">
        <label className="form-label" style={{ fontSize: 15, lineHeight: "20px" }}>
          {getLabel(LangConstant.L_NEW_PASSWORD_CONFIRMATION)}
        </label>
        <input
          id="passwordConfirmation"
          type="password"
          className="form-control"
          placeholder={getLabel(LangConstant.P_NEW_PASSWORD)}
          onChange={onPasswordFormChange}
          value={form.passwordConfirmation}
          style={{ backgroundColor: "#f5f5f5" }}
        />
      </div>
      <button
        type="submit"
        className="btn btn-primary w-100"
        disabled={!passwordValidated}
        style={{ minHeight: 40, borderRadius: 4, fontSize: 15, lineHeight: "20px", fontWeight: 600 }}
      >
        {getLabel(LangConstant.L_CONTINUE_BUTTON)}
      </button>
      {passwordErrorMsg && (
        <small className="d-block text-center text-danger" style={{ paddingTop: 7 }}>
          {passwordErrorMsg}
        </small>
      )}
    </form>
  );
};

export default SetPasswordForm;

SetPasswordForm.prototype = {
  onSubmitPasswordForm: PropTypes.func,
  onPasswordFormChange: PropTypes.func,
  passwordValidated: PropTypes.bool,
  passwordErrorMsg: PropTypes.string,
  form: PropTypes.object,
};
